/**
 * 台风服务实现类
 */
const ITyphoonService = require('../../ITyphoonService');

/**
 * @constructor
 * @classdesc 台风服务接口
 * @alias G.service.TyphoonServiceImpl
 * @augments G.service.ITyphoonService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.yearUrl {String} 年份服务地址
 * @param opts.infoUrl {String} 详情服务地址
 * @param opts.currentUrl {String} 当前台风地址
 * @param [opts.source] {String} 台风数据来源，默认为温州;浙江水利厅：zjwater
 * @param [opts.crossOrigin] {Boolean} 是否跨域
 */
class TyphoonServiceImpl extends ITyphoonService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取当前台风
     * @inheritdoc
     */
    getCurrent(opts) {
        const _crossOrigin = this.opts.crossOrigin;        
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.currentUrl;
                let data = null;
                var self = this;                
                if (!url) {
                    resolve(data);
                }
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                if (_crossOrigin) {
                    this._jsonp({
                        url: url,
                        callback: function (result) {
                            data = result;
                            resolve(data);
                        }
                    })
                }else{
                    data = await this.opts.httpRequest.get(url);
                    resolve(data);    
                }
            } catch (e) {
                reject(e);
            }
        });        
    }

    /**
     * @inheritDoc
     */
    getTyphoonsByYear(opts) {
        const _source = this.opts.source;
        const _crossOrigin = this.opts.crossOrigin;        
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.yearUrl;
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                let data = null;
                var self = this;
                if (_crossOrigin) {
                    this._jsonp({
                        url: url,
                        callback: function (result) {
                            //浙江水利厅格式数据
                            data = result;
                            if (_source&&_source.toLowerCase()=="zjwater") {
                                data = self._parseZjwaterTyphoonYearList(data);                                
                            }
                            resolve(data);
                        }
                    }) 
                }else{
                    data = await this.opts.httpRequest.get(url);
                    //浙江水利厅格式数据
                    if (_source&&_source.toLowerCase()=="zjwater") {
                        data = this._parseZjwaterTyphoonYearList(data);
                    }
                    resolve(data);    
                }
            } catch (e) {
                reject(e);
            }
        });
    }

    /**
     *
     * @inheritDoc
     */
    getTyphoonInfo(opts) {
        const _source = this.opts.source;
        const _crossOrigin = this.opts.crossOrigin;
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.infoUrl;
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                let data = null;
                var self = this;
                if (_crossOrigin) {
                    this._jsonp({
                        url: url,
                        callback: function (result) {
                            //浙江水利厅格式数据
                            data = result;
                            if (_source&&_source.toLowerCase()=="zjwater") {
                                data = self._parseZjwaterTyphoon(data);                                
                            }
                            resolve(data);
                        }
                    })                   
                }else{
                    data = await this.opts.httpRequest.get(url);
                    //浙江水利厅格式数据
                    if (_source&&_source.toLowerCase()=="zjwater") {
                        data = this._parseZjwaterTyphoon(data);
                    }
                    resolve(data);                   
                }
            } catch (e) {
                reject(e);
            }
        });
    }
    _parseZjwaterTyphoonYearList(data){
        let result = [];
        let self = this;
        if (!!data) {
            data.forEach(element => {
                let obj = {};
                obj.content = element.name?element.name:null;
                obj.ename=element.enname?element.enname:null;
                obj.start=element.starttime?element.starttime.replace(/\//g,"-").replace(" ","T"):null;    
                obj.end=element.endtime?element.endtime.replace(/\//g,"-").replace(" ","T"):null;
                obj.id=element.tfid?parseInt(element.tfid):null;
                obj.is_current=element.isactive?parseInt(element.isactive):null;
                result.push(obj);
            });            
        }        
        return result;
    }
    //浙江水利厅转温州格式
    _parseZjwaterTyphoon(data){
        let result = [];
        let self = this;
        if (!!data) {
            data.forEach(element => {
                let obj = {};
                obj.begin_time=(element.starttime||'').replace(/\//g,"-").replace(" ","T");
                obj.ename=element.enname;
                obj.end_time=(element.endtime||'').replace(/\//g,"-").replace(" ","T");
                
                obj.is_current=parseInt(element.isactive);
                obj.land=element.land;
                obj.name=element.name;
                obj.tfbh=element.tfid;
                obj.type="FeatureCollection";
                obj.features=self._parseZjwaterFeature(element.points);
                result.push(obj);
            });            
        }

        return result;
    }
    //构建风圈信息
    _parseRadisuQuad(radiusStr){
        let result = {
            ne:0,//0
            se:0,//1
            nw:0,//2
            sw:0//3
        }
        if (!!radiusStr) {
            const radisuArr = radiusStr.split("|");
            if (radisuArr.length==4) {
                result.ne=radisuArr[0];
                result.se=radisuArr[1];
                result.nw=radisuArr[2];
                result.sw=radisuArr[3];                
            }
        }
        return result;
    }
    //构建预测信息
    _parseForecast(data){
        let forecast = [];
        let self = this;
        if (!!data) {
            data.forEach(element => {
                let _forecast={};
                _forecast.features=self._parseZjwaterFeature(element.forecastpoints);
                _forecast.region=element.tm;
                _forecast.type="FeatureCollection";
                forecast.push(_forecast);
            });            
        }
        return forecast;
    }
    //构建features geojson对象
    _parseZjwaterFeature(points){
        let features = [];
        let self = this;
        if (!!points) {
            points.forEach(point => {
                let feature = {};
                let geom = {};
                geom.type="Point";
                geom.coordinates=[];
                geom.coordinates.push(parseFloat(point.lng));
                geom.coordinates.push(parseFloat(point.lat));
                feature.geometry=geom;
    
                let properties={};
                properties.move_dir=point.movedirection;
                properties.move_speed=parseInt(point.movespeed);
                properties.power=parseInt(point.power);
                properties.pressure=parseInt(point.pressure);
                properties.radius7_quad=self._parseRadisuQuad(point.radius7);
                properties.radius10_quad=self._parseRadisuQuad(point.radius10);
                properties.radius12_quad=self._parseRadisuQuad(point.radius12);
                properties.speed=parseInt(point.speed);
                properties.strong=point.strong;
                properties.time=(point.time||'').replace(/\//g,"-").replace(" ","T");
                properties.forecast=self._parseForecast(point.forecast);
                feature.properties = properties;
                feature.type="Feature";
                features.push(feature);
            });            
        }

        return features;
    }
     _jsonp(opt){
        var cbFuncName = 'typhoonCallback' + Math.random().toString().replace('.','');
        window[cbFuncName] = function(object) {
            opt.callback(object);
            document.getElementsByTagName("body")[0].removeChild(script);
        }
        var script = document.createElement("script");
        //组合请求URL
        if (opt.url.indexOf("?")>=0) {
            script.src = opt.url + "&callback="+cbFuncName;
        }else{
            script.src = opt.url + "?callback="+cbFuncName;
        }
        
        //将创建的新节点添加到BOM树上
        document.getElementsByTagName("body")[0].appendChild(script);

    }
}
module.exports = TyphoonServiceImpl;